// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backend: {
    baseUrl: window["env"]["BACKEND_URL"],
  },
  baseUrl: window["env"]["FRONTEND_URL"],
  siteName: window["env"]["SITE_NAME"],
  baseHref: window["env"]["BASE_HREF"],
  firebase: {
    apiKey: window["env"]["FIREBASE_API_KEY"],
    authDomain: window["env"]["FIREBASE_AUTH_DOMAIN"],
    projectId: window["env"]["FIREBASE_PROJECT_ID"],
    storageBucket: window["env"]["FIREBASE_STORAGE_BUCKET"],
    messagingSenderId: window["env"]["FIREBASE_MESSAGING_SENDER_ID"],
    appId: window["env"]["FIREBASE_APP_ID"],
    vapidKey: window["env"]["FIREBASE_VAPID_KEY"],
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
